import { BlockResult } from "./toBlockResult";

export function getSortedRounds(result: { rounds: BlockResult["rounds"] }) {
  return Object.keys(result.rounds)
    .map((key) => parseInt(key))
    .sort((a, b) => a - b);
}
